export default "__VITE_ASSET__89cfea4b__"